import { BaseAPI, Common } from '../common';

import ApiInstance from './apiInstance';
import ApiInstanceField from './apiInstanceField';
import CanonicalFieldType from './canonicalFieldType';
import CanonicalField from './canonicalField';
import CopilotSession from './copilot/session';
import Credential from './credential';
import CredentialCheckout from './ehrCredentials/checkouts';
import EhrInstance from './ehrInstance';
import EhrInstanceAlert from './ehrInstanceAlert';
import EhrInstanceField from './ehrInstanceField';
import JobConfig from './jobConfig';
import JobValidation from './jobValidation';
import ManualJob from './manualJob';
import PracticeConfig from './practiceConfig';
import PracticeConfigApiInstance from './practiceConfig/apiInstance';
import PracticeConfigEhrInstance from './practiceConfig/ehrInstance';
import Queue from './queue';

export class API extends BaseAPI {
  ApiInstance: ApiInstance;
  ApiInstanceField: ApiInstanceField;
  CanonicalFieldType: CanonicalFieldType;
  CanonicalField: CanonicalField;
  CopilotSession: CopilotSession;
  Credential: Credential;
  CredentialCheckout: CredentialCheckout;
  EhrInstance: EhrInstance;
  EhrInstanceAlert: EhrInstanceAlert;
  EhrInstanceField: EhrInstanceField;
  JobConfig: JobConfig;
  JobValidation: JobValidation;
  ManualJob: ManualJob;
  PracticeConfig: PracticeConfig;
  PracticeConfigApiInstance: PracticeConfigApiInstance;
  PracticeConfigEhrInstance: PracticeConfigEhrInstance;
  Queue: Queue;

  constructor(common: Common) {
    super(common);
    this.ApiInstance = new ApiInstance(common);
    this.ApiInstanceField = new ApiInstanceField(common);
    this.CanonicalFieldType = new CanonicalFieldType(common);
    this.CanonicalField = new CanonicalField(common);
    this.CopilotSession = new CopilotSession(common);
    this.Credential = new Credential(common);
    this.CredentialCheckout = new CredentialCheckout(common);
    this.EhrInstance = new EhrInstance(common);
    this.EhrInstanceAlert = new EhrInstanceAlert(common);
    this.EhrInstanceField = new EhrInstanceField(common);
    this.JobConfig = new JobConfig(common);
    this.JobValidation = new JobValidation(common);
    this.ManualJob = new ManualJob(common);
    this.PracticeConfig = new PracticeConfig(common);
    this.PracticeConfigApiInstance = new PracticeConfigApiInstance(common);
    this.PracticeConfigEhrInstance = new PracticeConfigEhrInstance(common);
    this.Queue = new Queue(common);
  }
}
